export const enum MarketingTopic {
  IqText = 'iq_text',
  LeftRight = 'left_right',
  Memory = 'dementia',
  Personality = 'personality',
}

const MARKETING_TOPIC_QUERY_PARAM = 'mt'

const MARKETING_TOPIC_BY_QUERY_VALUE: Record<string, MarketingTopic> = {
  [MarketingTopic.IqText]: MarketingTopic.IqText,
  [MarketingTopic.LeftRight]: MarketingTopic.LeftRight,
  [MarketingTopic.Memory]: MarketingTopic.Memory,
  [MarketingTopic.Personality]: MarketingTopic.Personality,
  lr: MarketingTopic.LeftRight,
  d: MarketingTopic.Memory,
  p: MarketingTopic.Personality,
}

const getMarketingTopicRawFromSearch = (search: string): string | null => {
  const searchParams = new URLSearchParams(search)

  return searchParams.get(MARKETING_TOPIC_QUERY_PARAM)
}

export const getMarketingTopicFromRawValue = (
  rawTopic: string | null,
): MarketingTopic => {
  if (!rawTopic) {
    return MarketingTopic.IqText
  }

  return (
    MARKETING_TOPIC_BY_QUERY_VALUE[rawTopic.trim().toLowerCase()] ||
    MarketingTopic.IqText
  )
}

export const getMarketingTopicFromSearch = (search: string): MarketingTopic =>
  getMarketingTopicFromRawValue(getMarketingTopicRawFromSearch(search))

export const isAdaptiveMarketingTopic = (topic: MarketingTopic): boolean =>
  topic === MarketingTopic.LeftRight ||
  topic === MarketingTopic.Memory ||
  topic === MarketingTopic.Personality

export const MARKETING_TOPIC_HERO_IMAGE_IDS = [
  'cohorts/intl_2lw/assets/images/offer/marketing-topics/left-right/hero.png',
  'cohorts/intl_2lw/assets/images/offer/marketing-topics/d/hero.png',
  'cohorts/intl_2lw/assets/images/offer/marketing-topics/personality/hero.png',
] as const
